<template>
  <div v-loading="loading" class="h-100 container project-edit-container">
    <!--  订单信息    -->
    <part-base ref="partBase" :key="'base' + key" :form-data.sync="formData" :show-add-btn="!!$route.query.id"
               :is-pre-executor="parseInt($route.query.isPreExecutor) === 1"
               :pt="parseInt($route.query.pt)"
               @saved="saved"
               @goBack="goBack"
               @refresh="getOrderDetail"/>

    <!--  子订单信息  -->
    <child-orders :key="'orders' + key" :pid="id" :project="formData"/>

  </div>
</template>

<script>
import PartBase from "./components/PartBase";
import ChildOrders from "./components/PartChildOrders";
import {getPukeDetailBase} from "@/api/regulars";
import {replaceArr} from '@/views/adOrder/regular/replaceData'

// 表单数据结构
const ModelFormData = {
  project_type:3,//普客订单=3
  company_id: null, // 乙方
  customer_name: '', //客户姓名
  customer_nature: '', //客户性质
  customer_id: '', // 客户ID
  customer_name_custom: null,
  exec_customer_id: null, // 执行公司id
  exec_customer_name: '', // 执行公司名称
  sale: '', //销售
  sale_id: '', // 销售ID
  executor: '', // 执行
  executor_id: '', // 执行ID
  brand: '', // 选中的代理品牌
  trade: '', // 行业
  product: '', // 产品
  order_source: '', // 订单来源
  cooperate_mode: '', // 合作形式
  product_category: '', // 品类
  price_range: '', // 客单
  project_name: null,
  // strategy_name: null, // 策略人名
  // strategy_id: null, // 策略人ID
  // planner_name: null, // 策划人名
  // planner_id: null, // 策划人ID
  // medium_name: null, // 媒介人
  // medium_id: null, // 媒介人ID
  //其他
  order_type: 'regular', //订单类型：regular【普通订单】、strike【冲账订单】
  //折扣
  discount: '',
  //规则
  rule: ''
};
export default {
  name: "EditRegulars",
  components: { PartBase, ChildOrders},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
  },
  data() {
    return {
      id: null,
      key: new Date().getTime(),
      loading: false,
      formData: {...{}, ...ModelFormData},
      replaceArr: replaceArr,
      isPreExecutor: 0,

    }
  },
  created() {
    this.id = this.$route.params && this.$route.params.id;
    this.isPreExecutor = this.$route.params && this.$route.params.isPreExecutor;
    this.getOrderDetail()

  },
  methods: {
    goBack() {
      this.$router.push({name: "ad_regulars"});
    },
    //修改订单后
    saved() {
      this.showToast({
        h: this,
      })
      this.key = new Date().getTime()
      window.location.reload()
    },
    formatFormData() {
      this.replaceArr.forEach((item) => {
        if (this.formData[item.new]) {
          this.formData[item.old] = this.formData[item.new]
          delete this.formData[item.new]
        }
      })
      let oldArray = ['strategy_name', 'strategy_id', 'planner_name', 'planner_id', 'medium_name', 'medium_id']
      oldArray.forEach((item) => {
        if (!this.formData[item]) {
          this.formData[item] = null
        }
      })
      this.pukeShow=true

    },
    async getOrderDetail() {
      this.loading = true
      //获取订单信息 getOrderDetailBase
      const {model} = await getPukeDetailBase({id: this.id})
      this.loading = false
      this.formData = model.info
      // let replaceArr = [{old: 'passenger_order_interval', new: 'price_range'}, {old: 'form_of_cooperation', new: 'cooperate_mode'},{new:'customer_alias',old:'customer_name_custom '}]
      this.replaceArr.forEach((item) => {
        if (this.formData[item.new]) {
          this.formData[item.old] = this.formData[item.new]
          delete this.formData[item.new]
        }
      })
      if (this.formData.project_type && this.formData.project_type === 3) {
        //这里是普客打包订单
        this.formatFormData()
      }
      this.$refs.partBase.initOldCustomerData(this.formData)
    },
  }
}
</script>
<style lang="scss">
.project-edit-container {

  .form-rows {
    border: 1px solid rgb(221, 221, 221);
    border-radius: 6px;
    padding: 20px;
  }

  .card-title {
    position: relative;
    padding-left: 55px;
    margin-bottom: 8px;
    color: rgba(50, 50, 50, 1);
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }

  .card-title::after {
    content: "";
    position: absolute;
    bottom: 6.5px;
    left: calc(55px - 8px - 6px);
    width: 8px;
    height: 8px !important;
    background: rgba(224, 63, 61, 1);
    border-radius: 2px;
  }
}

</style>
